import * as env from './env.json';

export const environment = {
  production: env.IS_PRODUCTION,
  uri: env.API_URL,
  token: env.AUTH_TOKEN,
  title: env.TITLE,
};
